import { application } from './application'

import StripeController from "./stripe_controller"
application.register("stripe", StripeController)

import AdminPaymenttypeToggleController from './admin_paymenttype_toggle_controller'
application.register('admin_paymenttype_toggle', AdminPaymenttypeToggleController)

import NewsletterController from './newsletter_controller'
application.register('newsletter', NewsletterController)

import AccessKeyModalController from './access_key_modal_controller'
application.register('access-key-modal', AccessKeyModalController)

import BallotEmailController from './ballot_email_controller'
application.register('ballot-email', BallotEmailController)

import EligibilityDetailsController from './eligibility_details_controller'
application.register('eligibility-details', EligibilityDetailsController)

import AuditLogsController from './audit_logs_controller'
application.register('audit-logs', AuditLogsController)

import SubmitOnCmdEnterController from './submit_on_cmd_enter_controller'
application.register('submit-on-cmd-enter', SubmitOnCmdEnterController)

import SeparateFamilyRefreshController from './separate_family_refresh_controller'
application.register('separate-family-refresh', SeparateFamilyRefreshController)

import AutofocusController from './autofocus_controller'
application.register('autofocus', AutofocusController)

import TooltipController from './tooltip_controller'
application.register('tooltip', TooltipController)

import SendEmailController from './send_email_controller'
application.register('send-email', SendEmailController)

import QrCodeClipboardController from './qr_code_clipboard_controller'
application.register('qr-code-clipboard', QrCodeClipboardController)

import CountryAddressController from './country_address_controller'
application.register('country-address', CountryAddressController)

import LtsTierPreviewController from './lts_tier_preview_controller'
application.register('lts-tier-preview', LtsTierPreviewController)

import LtsEndDateController from './lts_end_date_controller'
application.register('lts-end-date', LtsEndDateController)

import LtsTierToggleController from './lts_tier_toggle_controller'
application.register('lts-tier-toggle', LtsTierToggleController)

import PublicComputerController from './public_computer_controller'
application.register('public-computer', PublicComputerController)

import EventLocationController from './event_location_controller'
application.register('event-location', EventLocationController)

import EventFormController from './event_form_controller'
application.register('event-form', EventFormController)

import EventTimesController from './event_times_controller'
application.register('event-times', EventTimesController)

import QrScannerController from './qr_scanner_controller'
application.register('qr-scanner', QrScannerController)

import CheckInFormController from './check_in_form_controller'
application.register('check-in-form', CheckInFormController)
